interface CustomSessionBannerProps {
  fieldName: string;
  count: number;
  onCancel: () => void;
  onSave: () => void;
}

export default function CustomSessionBanner({
  fieldName,
  count,
  onCancel,
  onSave,
}: CustomSessionBannerProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 rounded-2xl border border-[#FC480D]/30 bg-[#FFF5EE] p-4 sm:flex-row sm:items-center sm:justify-between text-sm">
      <div className="text-[#0E1726]">
        <span className="font-semibold text-[#FC480D]">{fieldName} · Custom:</span>{' '}
        <span>klik kotak jam di kalender yang ingin dibuka ({count} sesi dipilih)</span>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <button
          type="button"
          onClick={onCancel}
          className="h-9 rounded-full border border-[#E0E6ED] bg-white px-4 text-xs font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50"
        >
          Batal
        </button>
        <button
          type="button"
          onClick={onSave}
          className="h-9 rounded-full bg-[#FC480D] px-4 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-[#E8490F]"
        >
          Simpan Sesi
        </button>
      </div>
    </div>
  );
}
